import type {BulkOperationResponseBody} from '../types/api/bulkOperations';

/** Immediate client-side representation of a just-accepted operation, shown until detail arrives. */
export function createPendingBulkOperation(args: {
  actionCode: string;
  bulkOperationId: string;
  resourceId: string;
  totalCount: number;
}): BulkOperationResponseBody {
  return {
    ...args,
    state: 'PENDING',
    doneCount: 0,
    failedCount: 0,
    skippedCount: 0,
    createdAt: new Date().toISOString(),
    finishedAt: null,
    errorCode: null,
    errorMessage: null,
  };
}
